"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PreviewerContext_1 = require("../../PreviewerContext");
exports.default = {
    lottieStyle: {
        width: 200,
        height: 200,
    },
    label: {
        color: PreviewerContext_1.PreviewerTheme.colors.primary.text,
        fontWeight: 'bold',
    },
};
